import React from 'react';
import Link from 'gatsby-link'

import Block from './block';

const BlockExpertise = ({ imageUrl, imageAlt, pageTitle, title, children, link }) => (
  <Block hasDecoration={!!pageTitle} className="block-expertise">
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-7 block-expertise-image mb-4 mb-md-0">
          <div className="decoration">
            <img className="w-100 img-fluid block-content-image" src={imageUrl} alt={imageAlt} />
          </div>
        </div>
        <div className="col-12 col-md-5 offset-md-1 block-expertise-content">
          <p className="block-expertise-title">{title}</p>
          <div className="block-expertise-content-true">
            {children}
          </div>
          <Link to={link} className="btn btn-primary">Voir la galerie</Link>
        </div>
      </div>
    </div>
  </Block>
)

export default BlockExpertise;



// WEBPACK FOOTER //
// ./src/components/block-expertise.js